import { globals, page as pageIndex } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
import { logOut } from './auth'
import {
  GET_COUNTRIES_FETCHED,
  GET_COUNTRY_REGIONS_FETCHED,
  GET_ALL_REGIONS_FETCHED } from './regions'
import { showModal, hideModal } from './modal'
import { sortAlphabetical } from './helpers'
// ------------------------------------
// Constants
// ------------------------------------
export const GET_AGENCIES_START = 'GET_AGENCIES_START'
export const GET_AGENCIES_FAILURE = 'GET_AGENCIES_FAILURE'
export const GET_AGENCIES_SUCCESS = 'GET_AGENCIES_SUCCESS'
export const GET_AGENCY_HISTORY_START = 'GET_AGENCY_HISTORY_START'
export const GET_AGENCY_HISTORY_FAILURE = 'GET_AGENCY_HISTORY_FAILURE'
export const GET_AGENCY_HISTORY_SUCCESS = 'GET_AGENCY_HISTORY_SUCCESS'
export const DELETE_AGENCY_START = 'DELETE_AGENCY_START'
export const DELETE_AGENCY_SUCCESS = 'DELETE_AGENCY_SUCCESS'
export const DELETE_AGENCY_FAILURE = 'DELETE_AGENCY_FAILURE'
export const CREATE_AGENCY_START = 'CREATE_AGENCY_START'
export const CREATE_AGENCY_SUCCESS = 'CREATE_AGENCY_SUCCESS'
export const CREATE_AGENCY_FAILURE = 'CREATE_AGENCY_FAILURE'
export const UPDATE_AGENCY_START = 'UPDATE_AGENCY_START'
export const UPDATE_AGENCY_SUCCESS = 'UPDATE_AGENCY_SUCCESS'
export const RESTORE_AGENCY_SUCCESS = 'RESTORE_AGENCY_SUCCESS'
export const UPDATE_AGENCY_FAILURE = 'UPDATE_AGENCY_FAILURE'
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}

export function getAgencies (country, state, agency) {
  return (dispatch) => {
    dispatch({ type: GET_AGENCIES_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    const countryV = country && country !== '*' ? `country=${country}` : ''
    const stateV = state && state !== '*' ? `state=${state}` : ''
    const agencyV = agency && agency !== '*' ? `agency=${agency}` : ''
    const params = countryV || stateV || agencyV ? '?' : ''
    const paramOptions = countryV || stateV || agencyV
      ? [countryV, stateV, agencyV].filter(item => item).join('&') : ''
    fetch(`${globals.apiUrl}/agency${params}${paramOptions}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: GET_AGENCIES_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_AGENCIES_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_AGENCIES_FAILURE, json: err })
    })
  }
}

function returnDropDownOptions (data, value, label) {
  let options = []
  for (let i = 0; i < data.length; i++) {
    if (!options.find(item => item.label === data[i][label])) {
      options = [...options, {
        value: data[i][value],
        label: data[i][label].trim()
      }]
    }
  }
  return options
}

function sortAgencies (agencies) {
  return agencies.sort(function (a, b) {
    if (`${a['State']} ${a['AgencyName'].toLowerCase()}` <
      `${b['State']} ${b['AgencyName'].toLowerCase()}`) { return -1 }
    if (`${a['State']} ${a['AgencyName'].toLowerCase()}` >
      `${b['State']} ${b['AgencyName'].toLowerCase()}`) { return 1 }
    return 0
  })
}

export function getAgencyHistory (searchOptions) {
  return (dispatch) => {
    dispatch({ type: GET_AGENCY_HISTORY_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    const setSearchOptions = searchOptions ? `?search=${searchOptions.split(' ').join('*')}` : ''
    fetch(`${globals.apiUrl}/agencyhistory${setSearchOptions}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: GET_AGENCY_HISTORY_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_AGENCY_HISTORY_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_AGENCY_HISTORY_FAILURE, json: err })
    })
  }
}

export function deleteAgency (agencyId) {
  return (dispatch) => {
    dispatch({ type: DELETE_AGENCY_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/agency/${agencyId}`, options).then((response) => {
      if (response.status === 200 || response.status === 204) {
        dispatch({
          type: DELETE_AGENCY_SUCCESS,
          agencyId
        })
        dispatch(hideModal('Delete-agency'))
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: DELETE_AGENCY_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    })
  }
}

export function createAgency (agencyObj) {
  return (dispatch) => {
    dispatch({ type: CREATE_AGENCY_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(agencyObj)
    }
    fetch(`${globals.apiUrl}/agency`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: CREATE_AGENCY_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        if (json.Message) {
          dispatch({ type: CREATE_AGENCY_FAILURE, json: json.Message, object: json })
          dispatch(showModal(json.Message == 'Agency already exists and is deleted' ? 'Restore-modal' : 'Error'))
        } else {
          dispatch({
            type: CREATE_AGENCY_SUCCESS,
            payload: {
             json
            }
          })
          dispatch(hideModal('Add-new-item-agency'))
        }
      }
    })
  }
}

export function updateAgency (agencyObj, allAgencies) {
  return (dispatch) => {
    dispatch({ type: UPDATE_AGENCY_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(agencyObj)
    }
    fetch(`${globals.apiUrl}/agency`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({ type: UPDATE_AGENCY_FAILURE, json: text })
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        if (json.Message) {
          dispatch({ type: UPDATE_AGENCY_FAILURE, json: json.Message })
          dispatch(showModal('Error'))
        } else if (allAgencies.find(item => item.Id === json.Id)) {
          dispatch({
            type: UPDATE_AGENCY_SUCCESS,
            payload: {
              json
            }
          })
          dispatch(hideModal('Edit-item-agency'))
        } else {
          dispatch({
            type: RESTORE_AGENCY_SUCCESS,
            payload: {
              json
            }
          })
          dispatch(hideModal('Restore-modal'))
          dispatch(hideModal('Add-new-item-agency'))
        }
      }
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.agencyEdit
  ? state : actionHandler(state, action),
  [GET_AGENCIES_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_AGENCIES_SUCCESS] : (state, action) => {
    const { json } = action.payload
    const agencyOptions = returnDropDownOptions(json, 'Id', 'AgencyName')
    const sortedOptions = [{ value: '*', label: 'All Agencies' }, ...sortAlphabetical(agencyOptions, 'label')]
    let statesList = []
    json.forEach(element => {
      if (!statesList.includes(element.State)) {
        statesList = [...statesList, element.State]
      }
    })
    statesList = statesList.map(item => {
      return {
        label: item,
        value: item
      }
    })
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        allAgencies: json,
        agencies: sortedOptions,
        clientAgencies: sortAgencies(json),
        agencyStates: [{ value: '*', label: 'All States' }, ...statesList]
      }
    }
  },
  [GET_AGENCIES_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [GET_COUNTRIES_FETCHED] : (state, action) => {
    const { json } = action.payload
    const countries = [
      { value: '*', label: 'All Countries' },
      ...json.map(item => {
        return {
          label: item,
          value: item
        }
      })
    ]
    return {
      ...state,
      renderData: {
        ...state.renderData,
        agencyCountries: countries,
        addAgencyCountries: countries.filter(item => item.value !== '*')
      }
    }
  },
  [GET_AGENCY_HISTORY_START] : (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        history: undefined
      }
    }
  },
  [GET_AGENCY_HISTORY_SUCCESS] : (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        history: action.payload.json
      }
    }
  },
  [GET_AGENCY_HISTORY_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [DELETE_AGENCY_START] : (state) => {
    return {
      ...state
    }
  },
  [DELETE_AGENCY_SUCCESS] : (state, action) => {
    const { agencyId } = action
    const agencies = state.renderData.clientAgencies.filter(item => item.Id !== agencyId)
    return {
      ...state,
      renderData: {
        ...state.renderData,
        deleted: agencyId,
        clientAgencies: agencies,
        allAgencies: agencies
      }
    }
  },
  [DELETE_AGENCY_FAILURE] : (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [CREATE_AGENCY_START] : (state) => {
    return {
      ...state
    }
  },
  [CREATE_AGENCY_SUCCESS] : (state, action) => {
    const { json } = action.payload
    const stateValue = state.formDataValue.AE.queryLine.radio.state
    const agencyValue = state.formDataValue.AE.queryLine.radio.agency
    const allAgencies = [...state.renderData.allAgencies, json]
    const agencyOptions = returnDropDownOptions(allAgencies, 'Id', 'AgencyName')
    const sortedOptions = [{ value: '*', label: 'All Agencies' }, ...sortAlphabetical(agencyOptions, 'AgencyName')]
    let newClientAgencies
    if (stateValue !== '*') {
      newClientAgencies = allAgencies.filter(item => item.State === json.State)
    } else if (agencyValue !== '*') {
      const agencyName = state.renderData.allAgencies.find(item => item.Id === agencyValue)
      newClientAgencies = allAgencies.filter(item => item.AgencyName === agencyName.AgencyName)
    } else {
      newClientAgencies = allAgencies
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        allAgencies: allAgencies,
        agencies: sortedOptions,
        clientAgencies: sortAgencies(newClientAgencies)
      },
      formDataValue: {
        AE: {
          ...state.formDataValue.AE,
          newAgency: {
            radio: {
              country: '',
              state: ''
            },
            textValues: {
              agency: ''
            }
          }
        }
      }
    }
  },
  [CREATE_AGENCY_FAILURE] : (state, action) => {
    const { json, object } = action
    return {
      ...state,
      errorCode: json,
      renderData: {
        ...state.renderData,
        agencyToRestore: object,
      }
    }
  },
  [UPDATE_AGENCY_START] : (state) => {
    return {
      ...state
    }
  },
  [UPDATE_AGENCY_SUCCESS] : (state, action) => {
    const { json } = action.payload
    const newAllAgencies = state.renderData.allAgencies.map(item => {
      if (item.Id === json.Id) {
        return json
      } else return item
    })
    const agencyOptions = returnDropDownOptions(newAllAgencies, 'Id', 'AgencyName')
    const sortedOptions = [{ value: '*', label: 'All Agencies' }, ...sortAlphabetical(agencyOptions, 'AgencyName')]
    const newClientAgencies = state.renderData.clientAgencies.map(item => {
      if (item.Id === json.Id) {
        return json
      } else return item
    })
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allAgencies: newAllAgencies,
        agencies: sortedOptions,
        clientAgencies: sortAgencies(newClientAgencies)
      },
      formDataValue: {
        AE: {
          ...state.formDataValue.AE,
          editAgency: {
            textValues: {
              agency: ''
            }
          }
        }
      }
    }
  },
  [RESTORE_AGENCY_SUCCESS] : (state, action) => {
    const { json } = action.payload
    const allAgencies = state.renderData.allAgencies.find(item => item.Id === json.Id)
      ? state.renderData.allAgencies.map(item => {
        if (item.Id === json.Id) {
          return json
        } else return item
      })
      : [...state.renderData.allAgencies, json]
    let newClientAgencies
    const stateValue = state.formDataValue.AE.queryLine.radio.state
    const agencyValue = state.formDataValue.AE.queryLine.radio.agency
    const agencyOptions = returnDropDownOptions(allAgencies, 'Id', 'AgencyName')
    const sortedOptions = [{ value: '*', label: 'All Agencies' }, ...sortAlphabetical(agencyOptions, 'AgencyName')]
    if (stateValue !== '*') {
      newClientAgencies = allAgencies.filter(item => item.State === stateValue)
    } else if (agencyValue !== '*') {
      const agencyName = state.renderData.allAgencies.find(item => item.Id === agencyValue)
      newClientAgencies = allAgencies.filter(item => item.AgencyName === agencyName.AgencyName)
    } else {
      newClientAgencies = allAgencies
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        allAgencies: allAgencies,
        agencies: sortedOptions,
        clientAgencies: sortAgencies(newClientAgencies)
      },
      formDataValue: {
        AE: {
          ...state.formDataValue.AE,
          newAgency: {
            radio: {
              country: '',
              state: ''
            },
            textValues: {
              agency: ''
            }
          }
        }
      }
    }
  },
  [UPDATE_AGENCY_FAILURE] : (state, action) => {
    const { json } = action
    return {
      ...state,
      errorCode: json,
      renderData: {
        ...state.renderData
      }
    }
  },
  [GET_COUNTRY_REGIONS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        addAgencyStates: returnDropDownOptions(json, 'Name', 'Name')
      }
    }
  },
  [GET_ALL_REGIONS_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allStates: json
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {},
  formDataValue: {
    AE: {
      queryLine: {
        radio: {
          country: '*',
          state: '*',
          agency: '*'
        }
      },
      newAgency: {
        radio: {
          country: '',
          state: ''
        },
        textValues: {
          agency: ''
        }
      },
      editAgency: {
        textValues: {
          agency: ''
        }
      }
    }
  }
}

export default function agencyEditReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/agencyEdit.js